export type LimeInterval = { min: number; max: number; prescription: number };

export type LimeJobWithLowInterval = {
  values: Array<Array<number | null>>;
  intervals: LimeInterval[];
};

export function shouldOfferLowLimeAdjustment(
  job: LimeJobWithLowInterval | null | undefined,
  threshold: number
): boolean {
  const interval = job?.intervals?.[0];
  const rate = interval?.prescription;
  if (!job || !interval || rate == null) return false;
  return (
    Number.isFinite(rate) &&
    rate > 0 &&
    rate < threshold &&
    job.values.some((row) =>
      row.some(
        (value) => value !== null && value > 0 && value >= interval.min && value <= interval.max
      )
    )
  );
}

export function adjustLowLimeInterval<T extends LimeJobWithLowInterval>(job: T, rate: number): T {
  const firstInterval = job.intervals[0];
  return {
    ...job,
    intervals: [{ ...firstInterval, prescription: rate }, ...job.intervals.slice(1)],
    values: job.values.map((row) =>
      row.map((value) => {
        if (
          value === null ||
          value <= 0 ||
          value < firstInterval.min ||
          value > firstInterval.max
        ) {
          return value;
        }
        return rate;
      })
    ),
  };
}

export function getLowLimeAdjustmentTargets(
  currentJob: LimeJobWithLowInterval,
  futureJob: LimeJobWithLowInterval | null,
  threshold: number,
  isResumingJob: boolean
): Array<'current' | 'future'> {
  if (isResumingJob) return [];

  const targets: Array<'current' | 'future'> = [];
  if (shouldOfferLowLimeAdjustment(currentJob, threshold)) targets.push('current');
  if (shouldOfferLowLimeAdjustment(futureJob, threshold)) targets.push('future');
  return targets;
}

export function advanceLowLimeAdjustment(targets: Array<'current' | 'future'>): {
  remainingTargets: Array<'current' | 'future'>;
  showCurrentJob: boolean;
} {
  const remainingTargets = targets.slice(1);
  return {
    remainingTargets,
    showCurrentJob: remainingTargets[0] !== 'future',
  };
}
